var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQualityControlIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 76 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.1116 4.8103C36.1128 2.3346 39.8872 2.3346 41.8884 4.8103L45.2254 8.9384C46.4688 10.4765 48.5021 11.1372 50.4121 10.6236L55.5382 9.2454C58.6124 8.4188 61.6659 10.6373 61.8298 13.8165L62.103 19.1176C62.2049 21.0928 63.4615 22.8224 65.3086 23.5297L70.2658 25.4277C73.2387 26.5659 74.405 30.1556 72.669 32.8239L69.7741 37.2732C68.6955 38.9311 68.6955 41.0689 69.7741 42.7268L72.669 47.1761C74.405 49.8444 73.2387 53.4341 70.2658 54.5723L65.3086 56.4703C63.4615 57.1776 62.2049 58.9072 62.103 60.8824L61.8298 66.1835C61.6659 69.3627 58.6124 71.5812 55.5382 70.7546L50.4121 69.3764C48.5021 68.8628 46.4688 69.5235 45.2254 71.0616L41.8884 75.1897C39.8872 77.665 36.1128 77.665 34.1116 75.1897L30.7746 71.0616C29.5312 69.5235 27.4979 68.8628 25.5879 69.3764L20.4618 70.7546C17.3876 71.5812 14.3341 69.3627 14.1702 66.1835L13.897 60.8824C13.7951 58.9072 12.5385 57.1776 10.6914 56.4703L5.7342 54.5723C2.7613 53.4341 1.5949 49.8444 3.331 47.1761L6.2259 42.7268C7.3045 41.0689 7.3045 38.9311 6.2259 37.2732L3.331 32.8239C1.5949 30.1556 2.7613 26.5659 5.7342 25.4277L10.6914 23.5297C12.5385 22.8224 13.7951 21.0928 13.897 19.1176L14.1702 13.8165C14.3341 10.6373 17.3876 8.4188 20.4618 9.2454L25.5879 10.6236C27.4979 11.1372 29.5312 10.4765 30.7746 8.9384L34.1116 4.8103Z",
    stroke: "black",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 61C49.598 61 59 51.598 59 40C59 28.402 49.598 19 38 19C26.402 19 17 28.402 17 40C17 51.598 26.402 61 38 61Z",
    stroke: "black",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30 40.7188L34.0103 45.0313C34.9991 46.0947 36.6829 46.0947 37.6718 45.0313L47 35",
    stroke: "black",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQualityControlIcon);
export default __webpack_public_path__ + "static/media/QualityControlIcon.0c4ec1a4071d9f8255b0c62911810c0a.svg";
export { ForwardRef as ReactComponent };